import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const checkOperationHours = deliveryZoneId =>
  axios({
    method: 'get',
    url: `${publicAPI}/order/checkoperational/${deliveryZoneId}`,
  });
